export const mobile = '340px'
export const xs = '576px'
export const s = '768px'
export const m = '992px'
export const l = '1200px'
export const xl = '1600px'
